module.exports = __webpack_public_path__ + "img/Lorinthe-Logo-semi-transparant.8cc966a4.svg";